import * as UI from '@brewlogix/blx-ui'
import { HStack, Text, Box } from '@chakra-ui/react'
import { Location } from 'src/types/schema/graphql'
interface IOption {
    label: string
    value: string
    coordinates: number[]
    id: string
    type: string
    location: Location
}
export const formatOptionLabel = (item: IOption) => {
    return item?.type === 'place' && !item?.location ? (
        <div className='flex'>
            <UI.Icon customClasses='min-w-4 w-4 mr-1' slug='HeroIconsSolid.LocationMarker' />
            <p className='text-base'>{item?.label}</p>
        </div>
    ) : (
        <HStack>
            <UI.Icon
                customClasses='min-w-4 w-4 mr-1 align-self-center'
                theme='primary'
                slug='HeroIconsSolid.OfficeBuilding'
            />
            <Box>
                <Text>{item?.location?.title}</Text>
                <Text fontSize={12}>{item?.location?.brand?.title}</Text>
            </Box>
        </HStack>
    )
}
